import { makeVar } from '@apollo/client'

import { CountryIDs } from 'screens/ProjectExport/components/ProductionModal/components/VerifyAddress/components/SelectCountryModal'

export const phoneCountryCodeVar = makeVar<CountryIDs | ''>('')
export const addressCountryCodeVar = makeVar<CountryIDs | ''>('')
